module.exports = __webpack_public_path__ + "static/media/background-login-mobile-dark.05d7ae8a.jpg";